import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import Success from '@icons/Success';
import { useTranslation } from 'react-i18next';

interface Props {
    isChecked?: boolean;
    onClick?: () => void;
}

function PinCheckbox({ isChecked, onClick }:Props) {
    const { t } = useTranslation('easyCard');
    return (
        <Row spacing={1} onClick={onClick}>
            <Success color={isChecked ? colors.iconSuccess : colors.iconUnselected}/>
            <Text size='title'>
                {t('pin.useBio')}
            </Text>
        </Row>
    );
}

export default PinCheckbox;
